<template>
    <div class="article">
        <h6 class="title">{{details.title}}</h6>
        <p class="subtitle">
            <span class="person">
                <img src="@/assets/image/logo.svg" class="logo" alt="">
                {{details.publisher}}
            </span>
            <span class="time">{{details.releaseTime}}</span>
        </p>
        <div class="content" v-html="details.content"></div>
        <div class="btm">
            <p class="source"><sapn v-if="details.source">文章来源：{{details.source}}</sapn></p>
            <ul class="tag">
                <li class="item"
                    v-for="(tag,index) in details.tagNames"
                    :key="index">{{tag}}
                </li>
            </ul>
        </div>
        <div class="fixedBottom" v-if="isShowDown" id="downloadButton" @click="toDownload">
            <div class="left">
                <img class="logo" :src="require('@/assets/image/bill/logo.png')" alt="">
                <div class="content">
                    <h6 class="c-title">农当家app</h6>
                    <p class="c-subtitle">识病害丨问专家丨学农技</p>
                </div>
            </div>
            <div class="btn">下载</div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                details:{
                    title:'',
                    content:null,
                    publisher:'',
                    releaseTime:'',
                    source:'',
                    tagNames:[],
                    isShowDown: false
                },
            }
        },
        created() {
            const {infoNo, isDown} = this.$route.query || {}
            this.isShowDown = isDown  //是否显示“下载应用”按钮
            if(infoNo){
                this.getArticleDetail(infoNo)
            }else{
                // this.getArticleDetail('1347030483841622017')
                // this.getArticleDetail('1347066920519614465')
                this.$notify('未查询到infoNo,请重新访问有效链接')
            }
        },
        methods:{
            getArticleDetail(infoNo){
                this.$api.getArticleDetail({infoNo}).then(res=>{
                    if(res.code === 0){
                      this.details = res.data
                      document.title = this.details.title
                      if(this.details.content){
                        this.details.content = this.details.content.replace(/wx_fmt/g, 'test')
                      }
                    }
                })
            },
            //跳转下载
            toDownload() {
                // eslint-disable-next-line no-undef
                var data = OpenInstall.parseUrlParams();
                // eslint-disable-next-line no-undef
                new OpenInstall({
                    /*appKey必选参数，openinstall平台为每个应用分配的ID*/
                    appKey : "pzm0rx",
                    /*可选参数，自定义android平台的apk下载文件名；个别andriod浏览器下载时，中文文件名显示乱码，请慎用中文文件名！*/
                    //apkFileName : 'com.fm.openinstalldemo-v2.2.0.apk',
                    /*可选参数，是否优先考虑拉起app，以牺牲下载体验为代价*/
                    //preferWakeup:true,
                    /*自定义遮罩的html*/
                    //mask:function(){
                    //  return "<div id='openinstall_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
                    //},
                    /*openinstall初始化完成的回调函数，可选*/
                    onready : function() {
                        var m = this, button = document.getElementById("downloadButton");
                        button.style.visibility = "visible";

                        /*在app已安装的情况尝试拉起app*/
                        m.schemeWakeup();
                        /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
                        button.onclick = function() {
                            m.wakeupOrInstall();
                            return false;
                        }
                    }
                }, data);
            }
        }
    }
</script>

<style lang="scss">
    @import "@/styles/common";
    .article{
        max-width: 667px;
        margin: 0 auto;
        color: #1D2023;
        padding:20px 20px 0 20px;
        .title{
            text-align: left;
            color: #1D2023;
            font-size: 20px;
            margin-top: 30px;
        }
        .subtitle{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 0;
            font-size: 12px;
            .person{
                display: inline-flex;
                align-items: center;
                .logo{
                    width: 30px;
                    height: 30px;
                    margin-right: 8px;
                }
            }
        }
        .content{
            text-align: left;
            line-height: 2;
            font-size: 16px;

            img{
                display: block;
                margin: 0 auto;
                max-width: 100%;
            }
        }
        .btm{
            text-align: left;
            margin: 20px 0;
            padding-bottom:pxtovw(80);
            .source{
                color: #606972;
                padding-bottom: 10px;
                border-bottom: 1px solid #DCDCDC;
            }
            .tag{
                padding: 20px 0  pxtovw(30);
                .item{
                    display: inline-block;
                    font-size: 14px;
                    color: #606972;
                    padding: 4px 10px;
                    background:#F5F5F5;
                    margin-right: 5px;
                }
                .item:last-child{
                    margin-right: 0;
                }
            }

        }
    }

    .fixedBottom{
        position: fixed;
        bottom: pxtovw(20);
        width:90%;
        height:pxtovw(75);
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #fff;
        box-shadow: 0 0 pxtovw(8) 0 rgba(0, 0, 0, 0.15);

        .left{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .logo{
                width: pxtovw(44);
                height:pxtovw(44);
                margin: 0 pxtovw(12);
            }
            .content{
                 .c-title{
                     color: #1D2223;
                     font-size: pxtovw(16);
                 }
                .c-subtitle{
                    color: #6F747A;
                    font-size: pxtovw(12);
                }
            }
        }
        .btn{
            width: pxtovw(60);
            height:pxtovw(24);
            line-height:pxtovw(24);
            font-size: pxtovw(14);
            font-weight: 500;
            color: #FFF;
            background:#1F995B;
            border-radius:pxtovw(12);
            box-shadow: 0 0 pxtovw(8) 0 rgba(0, 0, 0, 0.15);
            margin-right: pxtovw(12);
        }
    }

    /*.fixedBottom {*/
    /*    position: fixed;*/
    /*    width: 100vw;*/
    /*    height: pxtovw(55);*/
    /*    display: flex;*/
    /*    justify-content: center;*/
    /*    align-items: center;*/
    /*    bottom: 0;*/
    /*    left: 0;*/
    /*    background: #fff;*/

    /*    .btn {*/
    /*        width: pxtovw(335);*/
    /*        margin: 0 auto;*/
    /*        height: pxtovw(47);*/
    /*        background: #00CE9F;*/
    /*        border-radius: pxtovw(4);*/
    /*        display: flex;*/
    /*        justify-content: center;*/
    /*        align-items: center;*/

    /*        p {*/
    /*            font-size: pxtovw(18);*/
    /*            color: #fff;*/
    /*        }*/
    /*    }*/

    /*    .btn:active {*/
    /*        background: rgba(0,206,159,.7);*/
    /*    }*/
    /*}*/
</style>
